import { type ThemeName, useLocalState } from "@huub-web/ui";
import type { ReactNode } from "react";

import { AppSettingsContext } from "../../contexts";

const ENV_THEME = (import.meta.env.VITE_THEME as ThemeName) || "light";

/**
 * @toso Use useLocalState
 */
export const AppSettingsProvider = ({
  debug = false,
  responseFeedback = false,
  children,
}: {
  debug?: boolean;
  responseFeedback?: boolean;
  children: ReactNode;
}) => {
  // States
  // ------

  const [theme, setTheme] = useLocalState<ThemeName>("theme", ENV_THEME);
  const [isAudioEnabled, setIsAudioEnabled] = useLocalState<boolean>(
    "audioEnabled",
    true,
  );
  const [isVisualDebugEnabled, setIsVisualDebugEnabled] =
    useLocalState<boolean>("visualDebugEnabled", false);

  // Handlers
  // --------

  const toggleAudio = () => setIsAudioEnabled((prev) => !(prev ?? true));
  const toggleVisualDebug = () =>
    setIsVisualDebugEnabled((prev) => !(prev ?? false));

  return (
    <AppSettingsContext.Provider
      value={{
        theme: theme ?? "light",
        setTheme,

        isAudioEnabled: isAudioEnabled ?? true,
        isVisualDebugEnabled: debug && (isVisualDebugEnabled ?? false),
        disableAudio: () => setIsAudioEnabled(false),

        isResponseFeedbackEnabled: responseFeedback,
        setIsResponseFeedbackEnabled: () => {
          console.warn(
            "setIsResponseFeedbackEnabled not implemented",
            responseFeedback,
          );
        },

        toggleAudio,
        toggleVisualDebug,
      }}
    >
      {children}
    </AppSettingsContext.Provider>
  );
};
